import type { SVGProps } from 'react';
const SvgTransitEnterexit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#transit_enterexit_svg__a)">
      <path
        fill="currentColor"
        d="M16 18H6V8h3v4.77L15.98 6 18 8.03 11.15 15H16v3Z"
      />
    </g>
    <defs>
      <clipPath id="transit_enterexit_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTransitEnterexit;
